import { render, staticRenderFns } from "./send-rule.vue?vue&type=template&id=e9b616ee&scoped=true&"
import script from "./send-rule.vue?vue&type=script&lang=js&"
export * from "./send-rule.vue?vue&type=script&lang=js&"
import style0 from "./send-rule.vue?vue&type=style&index=0&id=e9b616ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b616ee",
  null
  
)

export default component.exports